import { REHYDRATE } from 'redux-persist/constants';

import createReducer from '../helpers/CreateReducer';
import { NavigationConstants } from '../constants/actions';

interface NavigationState {
  locationHistory: string[];
  navigationContext: string;
  rehydrated?: boolean;
}

interface AddLocationHistoryAction {
  type: typeof NavigationConstants.ADD_LOCATION_HISTORY;
  path: string;
}

interface DeleteLastLocationHistoryAction {
  type: typeof NavigationConstants.DELETE_LAST_LOCATION_HISTORY;
  entries: number;
}

interface RehydrateAction {
  type: typeof REHYDRATE;
  payload: {
    navigation: Partial<NavigationState>;
  };
}

export const getInitialState = (): NavigationState => ({
  locationHistory: [],
  navigationContext: ''
});

export default createReducer(getInitialState, {
  [NavigationConstants.ADD_LOCATION_HISTORY]: (
    state: NavigationState,
    { path }: AddLocationHistoryAction
  ) => ({
    ...state,
    locationHistory: [path, ...state.locationHistory].slice(0, 15)
  }),

  [NavigationConstants.DELETE_LAST_LOCATION_HISTORY]: (
    state: NavigationState,
    { entries }: DeleteLastLocationHistoryAction
  ) => ({
    ...state,
    locationHistory: [...state.locationHistory].slice(entries)
  }),

  [`${REHYDRATE}`]: (state: NavigationState, { payload }: RehydrateAction) => ({
    ...state,
    ...payload.navigation,
    rehydrated: true
  })
});
